<template>
  <div class="shop-container app-container">
    <el-row :gutter="20">
      <el-col 
        v-for="product in list" 
        :key="product.Id" 
        :xs="24" 
        :sm="12" 
        :md="8" 
        :lg="6"
        class="product-item"
      >
        <el-card shadow="hover">
          <div slot="header" class="product-header">
            <h3>{{ product.Name }}</h3>
            <el-tag type="success" effect="dark">
              {{ product.Price }}金币
            </el-tag>
          </div>
          <div class="product-content">
            <p class="description">{{ product.Description }}</p>
            <div class="meta-info">
              <el-tag type="info">适用兵种：{{ formatArmyNames(product.ArmyNames) }}</el-tag>
              <el-tag type="info">使用次数：{{ product.UsageLimit }}</el-tag>
              <el-tag v-if="product.RequiredPermissionLevel > 0" :type="getPermissionType(product.RequiredPermissionLevel)">
                {{ getPermissionText(product.RequiredPermissionLevel) }}
              </el-tag>
            </div>
          </div>
          <div class="product-footer">
            <el-button 
              type="primary" 
              @click="handlePurchase(product.Id)"
              :loading="loadingMap[product.Id]"
            >
              <i class="el-icon-shopping-cart"></i> 立即购买
            </el-button>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-pagination
      layout="total, prev, pager, next"
      :current-page="page"
      :page-size="20"
      :total="total"
      @current-change="handlePageChange"
    />
  </div>
</template>

<script>
import { getProducts, purchaseProduct, getArmyTypeList } from '@/api/api'

export default {
  data() {
    return {
      list: [],
      total: 0,
      page: 1,
      loadingMap: {},
      armyList: [],
      armyLoading: true
    }
  },
  methods: {
    handleQuery() {
      getProducts({
        page: this.page,
        pageSize: 20
      }).then(res => {
        const response = res.data.response
        this.list = response.data
        this.total = response.dataCount
      })
    },

    fetchArmyTypes() {
      this.armyLoading = true
      getArmyTypeList({ page: 1, pageSize: 100 }).then(res => {
        this.armyList = res.data.response.data
      }).finally(() => {
        this.armyLoading = false
      })
    },

    async handlePurchase(productId) {
      this.$set(this.loadingMap, productId, true)
      try {
        const res = await purchaseProduct(productId)
        if (res.data.success) {
          this.$message.success('购买成功')
          this.handleQuery()
        }
        else 
        {
            this.handlePurchaseError(res)
        }
      } catch (error) {
      } finally {
        this.$set(this.loadingMap, productId, false)
      }
    },

    handlePurchaseError(res) {
      if (res.data.msg.includes('未绑定游戏角色')) {
        this.$confirm('需要先绑定游戏角色，是否前往绑定？', '提示', {
          confirmButtonText: '去绑定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        console.log("没有绑定")
          this.$router.push('/usercenter/profile')
        })
      } else {
        this.$message.error(error.response.data.msg || '购买失败')
      }
    },

    formatArmyNames(armyNames) {
      if (this.armyLoading) return '加载中...'
      return armyNames.split(',').map(code => {
        const army = this.armyList.find(a => a.Code === code)
        return army ? army.Name : code
      }).join('、')
    },

    handlePageChange(val) {
      this.page = val
      this.handleQuery()
    },

    getPermissionType(level) {
      const types = ['', 'success', 'warning', 'danger']
      return types[level] || 'info'
    },

    getPermissionText(level) {
      const texts = ['无限制', '总督权限', '提督权限', '舰长权限']
      return texts[level] || '未知权限'
    }
  },
  mounted() {
    this.handleQuery()
    this.fetchArmyTypes()
  }
}
</script>

<style scoped>
.shop-container {
  padding: 20px;
}

.product-item {
  margin-bottom: 20px;
}

.product-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.product-content {
  min-height: 170px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.description {
  color: #666;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 10px;
}

.meta-info .el-tag {
  max-width: 100%;
  white-space: normal;
  word-break: break-all;
  height: auto;
  min-height: 28px;
  line-height: 1.4;
  padding: 4px 8px;
  margin: 2px 0;
  align-items: center;
}

.el-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.el-card__body {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.meta-info {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}


.product-footer {
  margin-top: 15px;
  text-align: center;
}
</style>
